import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../../shared/hooks';
import { useField } from '@unform/core';
import { PivotService } from '../services/api/estoquefazenda/pivot/pivotservice';

type TAutoCompleteOption = {
  idpivot: string;
  label: string;
}
interface IAutoCompletePivotProps {
  isExternalLoading?: boolean;
  uuidPivots?: (novoTextoselect: string | undefined) => void;
  nome?: (novoTextoselect: string | undefined) => void;
}
export const AutoCompletePivotfazenda: React.FC<IAutoCompletePivotProps> = ({ isExternalLoading = false, uuidPivots, nome }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idpivot');
  const { debounce } = useDebounce();
  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);
  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');
  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);
  useEffect(() => {
    setIsLoading(true);

    setIsLoading(false);
    if(selectedId !== null){
       debounce(() => {  
      PivotService.getAlllistPivots( busca, selectedId)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(pivot => ({ idpivot: pivot.idpivot, label: pivot.descricao })));
          }
        });
    }); }
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;
    const selectedOption = opcoes.find(opcao => opcao.idpivot === selectedId);
    if (!selectedOption) return null;
    return selectedOption;
  }, [selectedId, opcoes]);

  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idpivot); uuidPivots?.(newValue?.idpivot); nome?.(newValue?.label); setBusca(''); clearError(); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Pivots" 
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};